import { useEffect, useState } from 'react';
import { useGetActivities } from 'api/activities';
import { ActivitiesParams, Activity } from 'api/activities/activities.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function ActivityAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getActivities } = useGetActivities();
  const [options, setOptions] = useState<Activity[]>([]);
  const [activitiesParams, setActivitiesParams] = useState<ActivitiesParams>({
    filterText: '',
    pageNumber: 1,
    resultSize: 25,
    type: 'FREIGHT,TERMINAL,FREIGHT_MAINTENANCE,FREIGHT_ADDON',
  });

  useEffect(() => {
    getActivities(activitiesParams);
  }, [getActivities, activitiesParams]);

  useEffect(() => {
    if (data?.length) {
      const fetchedOptions = data.map((activity) => ({
        id: activity.id,
        lock: activity.lock,
        comment: activity.comment,
        description: activity.description,
        enabled: activity.enabled,
        serviceType: activity.serviceType,
        exportEnabled: activity.exportEnabled,
        importEnabled: activity.importEnabled,
        countryEnabled: activity.countryEnabled,
        code: activity.code,
        granular: activity.granular,
        direct: activity.direct,
        discriminant: activity.discriminant,
        translations: activity.translations,
        incomeAccount: activity.incomeAccount,
        costAccount: activity.costAccount,
        billingAccount: activity.billingAccount,
        transportMeansSell: activity.transportMeansSell,
        tradeType: activity.tradeType,
      }));
      setOptions((prev) => [...prev, ...fetchedOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(option) => option.code}
      handleSearchChange={handleChange(setOptions, setActivitiesParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setActivitiesParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setActivitiesParams,
        formProps.field.onBlur,
      )}
    />
  );
}
